import script from "./CheckoutRightSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutRightSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutRightSidebar.vue?vue&type=style&index=0&id=019670c6&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019670c6"]])

export default __exports__